import React, { useState, useEffect, useMemo } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControlLabel,
  Checkbox,
  Box,
  Typography,
  Link,
  Tooltip,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';
import {
  PictureAsPdf,
  Image,
} from '@mui/icons-material';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';

import SecurityUtil from '../../../utils/SecurityUtils';

import * as gfileStore from "../../../store/gfiles";

// 한국어 로케일 설정
dayjs.locale('ko');

const NoticePopup = ({ notice, onClose, style }) => {
  const [dontShowToday, setDontShowToday] = useState(false);
  const [attachFiles, setAttachFiles] = useState([]);

  const sanitizedContent = useMemo(() => {
    return SecurityUtil.sanitizeHtml(notice?.content);
  }, [notice?.content]);

  const handleClose = () => {
    onClose();
  };

  const handleHideForToday = (e) => {
    if (e.target.checked) {
      setDontShowToday(true);
      console.log("dontShowToday is true", `notice_${notice.id}_dont_show`, dayjs().format('YYYY-MM-DD'));
      localStorage.setItem(`notice_${notice.id}_dont_show`, dayjs().format('YYYY-MM-DD'));
    }

    onClose();
  };

  useEffect(() => {
      if (notice && notice.attachments && Array.isArray(notice.attachments)) {
        setAttachFiles(notice?.attachments?.map(file => ({ ...file, downloading: false })))
      } else {
      setAttachFiles([]);
    }
  }, [notice]);

  const handleClickDownload = async (e, idx) => {
    e.stopPropagation();

    const { seq, refType, filename } = attachFiles[idx];
    
    const newAttachFiles = attachFiles.map((file, i) => (i === idx ? { ...file, downloading: true } : file));

    setAttachFiles(newAttachFiles);

    const res = await gfileStore.downloadFile(seq, refType);
    const blob = await res.blob(); // res.blob는 promise를 리턴함???
    
    // 2. Create blob link to download
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    // 3. Append to html page
    document.body.appendChild(link);
    // 4. Force download
    link.click();
    // 5. Clean up and remove the link
    link.parentNode.removeChild(link);

    setTimeout(() => {
      setAttachFiles(newAttachFiles.map((file, i) => (i === idx ? { ...file, downloading: false } : file)));
    }, 1000);
  }

  return (
    <Dialog
      open={true}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      disableBackdropClick={true}  // 백드롭 클릭 비활성화
      PaperProps={{
        sx: {
          width: 570,
          height: 650,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          ...style,
          '& p': {  // p 태그 스타일 추가
            margin: 0,  // 마진 제거
            padding: 0  // 패딩도 제거
          }
        }
      }}
    >
      <DialogTitle>{notice.title}</DialogTitle>
    <DialogContent 
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        height: 'calc(100% - 120px)', // DialogTitle과 DialogActions 높이를 제외한 높이
        p: 0 // 패딩 제거
      }}
    >
      {/* <Box sx={{ 
        flex: 1,
        overflowY: 'auto',
        p: 3 // 내용에만 패딩 적용
      }}>
        <div dangerouslySetInnerHTML={{ __html: notice.content }} />
      </Box> */}
      <Box 
        component="div"
        sx={{ 
          flex: 1,
          overflowY: 'auto',
          p: 3, // 내용에만 패딩 적용
          minHeight: '300px',
          whiteSpace: 'pre-wrap', // 연속된 공백, 줄바꿈 을 보존
        }}
        dangerouslySetInnerHTML={{ __html: sanitizedContent }}
      />
      {notice.attachments && notice.attachments.length > 0 && (
        <Box sx={{ 
          borderTop: 1,
          borderColor: 'transparent',
          p: 0
        }}>
          <ul style={{ margin: 0, padding: 0 }}>
            {notice.attachments.map((file, index) => {
              const { filename } = file;
              const pos = filename.lastIndexOf(".");
              let ext = "";
              if (pos > -1) {
                ext = filename.substring(pos+1);
              }
              return (
                <ListItem key={index} disablePadding>
                  <Tooltip title="다운로드">
                  <ListItemButton 
                    onClick={(e) => handleClickDownload(e, index)}
                    sx={{
                      padding: '0 20px',
                      '&.MuiListItemButton-root': {
                        padding: '0 20px',
                        ...(index === 0 && { paddingTop: '10px' })  // index가 0일 때만 paddingTop 적용
                      }
                    }}
                  >
                      <ListItemIcon>
                        {ext.toLowerCase() === 'pdf' ? <PictureAsPdf /> : <Image />}
                      </ListItemIcon>
                      <ListItemText primary={filename} />
                    </ListItemButton>
                  </Tooltip>
                </ListItem>
              );
            })}
          </ul>
        </Box>
      )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', px: 3}}>
        <Box sx={{ pl: 2 }}>  {/* Box로 감싸서 패딩 적용 */}
          <FormControlLabel
            control={
              <Checkbox
                checked={dontShowToday}
                //onChange={(e) => setDontShowToday(e.target.checked)}
                onChange={handleHideForToday}
              />
            }
            label="오늘하루 열지않기"
          />
        </Box>
        <Button variant="text" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NoticePopup;